// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__1WOy4","errors":"Errors_errors__eG3WT"};